module.exports = __webpack_public_path__ + "img/24.e96c7e9e.png";